import { useEffect, useState } from "react";
import { scaleOrdinal } from "d3-scale";
import { schemePaired } from "d3-scale-chromatic";
import { useQuery } from "react-query";
import axios from "axios";
import { INIT_STYLE_VALUES } from "../../constants";
import { useAuth0 } from "@auth0/auth0-react";

const useLayerStyles = ({ onLayerStyleChange }) => {
  const [styleValues, setStyleValues] = useState(INIT_STYLE_VALUES);
  const { isAuthenticated, getAccessTokenSilently } = useAuth0();

  const buildScale = (values) => {
    const scale = scaleOrdinal(schemePaired);
    return values.reduce((acc, val) => {
      acc.push([val]);
      acc.push(scale(val));
      return acc;
    }, []);
  };

  const { data } = useQuery(
    ["filterData2", isAuthenticated],
    async () => {
      let headers = {};
      if (isAuthenticated) {
        const token = await getAccessTokenSilently();
        headers = { Authorization: `Bearer ${token}` };
      }
      try {
        const { data } = await axios.get(
          `${process.env.REACT_APP_ENDPOINT}/api/public-map/filters`,
          { headers }
        );
        return data;
      } catch (err) {
        console.error(err);
      }
    },
    {
      refetchOnWindowFocus: false,
    }
  );

  useEffect(() => {
    if (data) {
      setStyleValues((prevState) => ({
        ...prevState,
        locationTypes: {
          ...prevState.locationTypes,
          paint: {
            "circle-color": [
              "match",
              ["get", "locationtype"],
              ...buildScale(data.locationTypes.map((item) => item.display)),
              "#fff",
            ],
            "circle-stroke-width": 2,
            "circle-stroke-color": "black",
          },
        },
        streamSegments: {
          ...prevState.streamSegments,
          paint: {
            "circle-color": [
              "match",
              ["get", "stream_segment"],
              ...buildScale(data.streamSegments.map((item) => item.display)),
              "#fff",
            ],
            "circle-stroke-width": 2,
            "circle-stroke-color": "black",
          },
        },
        organizations: {
          ...prevState.organizations,
          paint: {
            "circle-color": [
              "match",
              ["get", "org_fav"],
              ...buildScale(data.organizations.map((item) => item.display)),
              "#fff",
            ],
            "circle-stroke-width": [
              "case",
              [">", ["length", ["get", "organizations"]], 1],
              5,
              2,
            ],
            "circle-stroke-color": [
              "case",
              [">", ["length", ["get", "organizations"]], 1],
              "white",
              "black",
            ],
          },
        },
      }));
    }
  }, [data]);

  const [activeStyle, setActiveStyle] = useState(styleValues.default);
  const styleOptions = Object.entries(styleValues).map(([key, value]) => ({
    display: value.name,
    value: key,
  }));

  const handleActiveStyle = (name) => {
    setActiveStyle(styleValues[name]);
    onLayerStyleChange(styleValues[name]);
  };

  return {
    activeStyle,
    handleActiveStyle,
    styleOptions,
    styleValues,
  };
};

export default useLayerStyles;
